export enum UrlQueryMatchTypeEnum {
  /* exact path and exact query */
  PATH_AND_QUERY_EXACT = "PATH_AND_QUERY_EXACT",
  /* exact path and query starts with */
  PATH_EXACT_QUERY_START_WITH = "PATH_EXACT_QUERY_START_WITH",
  /* exact path and query ends with */
  PATH_EXACT_QUERY_ENDS_WITH = "ENDS_WITH",
  /* exact path and query includes */
  PATH_EXACT_QUERY_INCLUDES = "INCLUDES",
  /* exact path and any query */
  BY_PATH_EXACT_ANY_QUERY = "BY_PATH_EXACT_ANY_QUERY",
  /* exact path and no query */
  BY_PATH_EXACT_NO_QUERY = "BY_PATH_EXACT_NO_QUERY",
  /* path starts with and any query */
  BY_PATH_START_WITH = "BY_PATH_START_WITH",
  /* any route where path includes given route part */
  BY_PATH_INCLUDES = "BY_PATH_INCLUDES",
}
